module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Letter Templates")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loadData($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.templateName),
      expression: "searchDto.templateName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchName"
    },
    domProps: {
      "value": (_vm.searchDto.templateName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "templateName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.letterTemplateTypeId),
      expression: "searchDto.letterTemplateTypeId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchTemplateType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchDto, "letterTemplateTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1
    }
  }, [_vm._v("All Unassigned")]), _vm._v(" "), _vm._l((_vm.templateTypeList), function(type) {
    return _c('option', {
      key: type.id,
      domProps: {
        "value": type.id
      }
    }, [_vm._v(_vm._s(type.description))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.workflowStatusId),
      expression: "searchDto.workflowStatusId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchWorkflowStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchDto, "workflowStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1
    }
  }, [_vm._v("All Unassigned")]), _vm._v(" "), _vm._l((_vm.allWorkflowStatusList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v(_vm._s(status.description))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_vm._v("Search")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/LetterTemplate",
      "tag": "button"
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpec.tableData,
      "columns": _vm.gridSpec.columns,
      "options": _vm.gridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/LetterTemplate/' + props.row.letterTemplateId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchName"
    }
  }, [_vm._v("Search Template Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchDbNumber"
    }
  }, [_vm._v("Search Template Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchDbNumber"
    }
  }, [_vm._v("Search Assigned Workflow")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-608382a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LetterTemplates.vue
// module id = 947
// module chunks = 1